export const SMART_FIX_INCENTIVES = [
  { icon: 'bolt', description: 'Get help now to fix common issues ' },
  { icon: 'thumbs-up', description: 'Easy step-by-step instructions' },
  { icon: 'home', description: 'Try it yourself - no engineer needed' },
];

export const SMART_FIX_HINTS = [
  `Please follow the instructions carefully. We take responsibility if you follow them correctly and they're not right. But we're not responsible for any issues if this guidance isn't followed properly.`,
  `For more help and safety information, check the 'warnings' section in your appliance manual.`,
  `If our virtual assistant can't solve it, you can still book an engineer. Give it a try?`,
];
